// Public company facts used by the existing bid-details fields.
// Each entry is tied to the carrier ID imported from the Top 100 DACH sheet.
export const carrierPublicProfiles = {
    1: {
        legalName: 'Deutsche Post AG (DHL Group)',
        established: 1969,
        address: 'Charles-de-Gaulle-Straße 20, 53113 Bonn, Germany',
        website: 'group.dhl.com',
        email: 'impressum.brief@deutschepost.de',
        phone: '+49 228 182-0',
        sources: [
            'https://group.dhl.com/en/legal-notice.html',
            'https://group.dhl.com/en/about-us/the-group/history.html',
        ],
    },
    3: {
        legalName: 'Kuehne + Nagel International AG',
        established: 1890,
        address: 'Dorfstrasse 50, 8834 Schindellegi, Switzerland',
        website: 'kuehne-nagel.com',
        phone: '+41 44 786 95 11',
        sources: [
            'https://www.kuehne-nagel.com/company/about/our-values',
            'https://2025-annual-report.kuehne-nagel.com/contact',
        ],
    },
    4: {
        legalName: 'DACHSER SE',
        established: 1930,
        address: 'Thomas-Dachser-Straße 2, 87439 Kempten, Germany',
        website: 'dachser.com',
        email: 'info@dachser.com',
        phone: '+49 831 5916 0',
        sources: [
            'https://www.dachser.com/en/imprint-306',
            'https://www.dachser.com/en/facts-figures-44',
        ],
    },
    5: {
        legalName: 'Rhenus SE & Co. KG',
        established: 1912,
        address: 'Rhenus-Platz 1, 59439 Holzwickede, Germany',
        website: 'rhenus.group',
        email: 'info@rhenus.com',
        phone: '+49 2301 29-0',
        sources: [
            'https://www.rhenus.group/in/en/imprint/',
            'https://www.rhenus.group/fileadmin/12_Rhenus_Group_Website/About_us/Sustainability/Rhenus-Group_Sustainability-Report-2024_01.pdf',
        ],
    },
    6: {
        legalName: 'LKW WALTER Internationale Transportorganisation AG',
        established: 1924,
        address: 'IZ NÖ-Süd, Straße 14, 2355 Wiener Neudorf, Austria',
        website: 'lkw-walter.com',
        email: 'austria@lkw-walter.com',
        phone: '+43 5 7777-0',
        sources: [
            'https://www.lkw-walter.com/int/en/imprint',
            'https://www.lkw-walter.com/int/en/about-us/company-profile',
        ],
    },
    7: {
        legalName: 'Gebrüder Weiss Gesellschaft m.b.H.',
        established: 1823,
        address: 'Bundesstraße 110, 6923 Lauterach, Austria',
        website: 'gw-world.com',
        phone: '+43 5574 696-0',
        sources: [
            'https://www.gw-world.com/at/unternehmen/standorte/austria/head-office',
            'https://www.gw-world.com/company/about-us/history/',
        ],
    },
    8: {
        legalName: 'Hellmann Worldwide Logistics SE & Co. KG',
        established: 1871,
        address: 'Elbestraße 1, 49090 Osnabrück, Germany',
        website: 'hellmann.com',
        email: 'info@hellmann.com',
        phone: '+49 541 605-0',
        sources: [
            'https://www.hellmann.com/en/about-us/company',
            'https://www.hellmann.com/en/legal',
        ],
    },
    9: {
        legalName: 'FIEGE Logistik Stiftung & Co. KG',
        established: 1873,
        address: 'Joan-Joseph-Fiege-Straße 1, 48268 Greven, Germany',
        website: 'fiege.com',
        email: 'info@fiege.com',
        phone: '+49 2571 999-0',
        sources: [
            'https://www.fiege.com/en/contact',
            'https://www.fiege.com/en/imprint',
        ],
    },
};

export const getCarrierPublicProfile = (carrierId) => (
    carrierPublicProfiles[Number(carrierId)] || null
);
